export const PERMISSIONS = {
  // Importaciones
  IMPORTS_ACCESS: 'imports:access',

  // Exportaciones
  EXPORTS_ACCESS: 'exports:access',

  // Importadores
  IMPORTERS_VIEW:   'importers:view',
  IMPORTERS_CREATE: 'importers:create',
  IMPORTERS_EDIT:   'importers:edit',
  IMPORTERS_DELETE: 'importers:delete',

  // Modos de importación
  IMPORT_MODES_VIEW:   'import_modes:view',
  IMPORT_MODES_CREATE: 'import_modes:create',
  IMPORT_MODES_EDIT:   'import_modes:edit',
  IMPORT_MODES_DELETE: 'import_modes:delete',

  // Unidades DAV
  DAV_UNITS_VIEW:   'dav_units:view',
  DAV_UNITS_CREATE: 'dav_units:create',
  DAV_UNITS_EDIT:   'dav_units:edit',
  DAV_UNITS_DELETE: 'dav_units:delete',

  // Unidades Comerciales
  COMMERCIAL_UNITS_VIEW:   'commercial_units:view',
  COMMERCIAL_UNITS_CREATE: 'commercial_units:create',
  COMMERCIAL_UNITS_EDIT:   'commercial_units:edit',
  COMMERCIAL_UNITS_DELETE: 'commercial_units:delete',

  // Transportadores
  CARRIERS_VIEW:   'carriers:view',
  CARRIERS_CREATE: 'carriers:create',
  CARRIERS_EDIT:   'carriers:edit',
  CARRIERS_DELETE: 'carriers:delete',

  // Subpartidas arancelarias
  SUBPARTIDAS_VIEW:   'subpartidas:view',
  SUBPARTIDAS_CREATE: 'subpartidas:create',
  SUBPARTIDAS_EDIT:   'subpartidas:edit',
  SUBPARTIDAS_DELETE: 'subpartidas:delete',

  // Productos
  PRODUCTS_VIEW:   'products:view',
  PRODUCTS_CREATE: 'products:create',
  PRODUCTS_EDIT:   'products:edit',
  PRODUCTS_DELETE: 'products:delete',

  // Negocios (borradores)
  BUSINESS_CREATE: 'business:create',
  BUSINESS_VIEW:   'business:view',

  // Operaciones
  OPERATIONS_VIEW:         'operations:view',
  OPERATIONS_EDIT:         'operations:edit',
  OPERATIONS_DELETE:       'operations:delete',
  OPERATIONS_APPROVE:      'operations:approve',
  OPERATIONS_DIAN_MANAGE:  'operations:dian_manage',
  OPERATIONS_EDI_GENERATE: 'operations:edi_generate',
  OPERATIONS_EDI_SEND:     'operations:edi_send',

  // EDI
  EDI_GENERATE: 'edi:generate',
  EDI_READ:     'edi:read',

  // Catálogo arancelario
  TARIFF_MANAGE: 'tariff:manage',
  TARIFF_VIEW:   'tariff:view',

  // Gestión de permisos
  PERMISSIONS_VIEW:   'permissions:view',
  PERMISSIONS_CREATE: 'permissions:create',
  PERMISSIONS_EDIT:   'permissions:edit',
  PERMISSIONS_DELETE: 'permissions:delete',

  // Gestión de roles
  ROLES_VIEW:   'roles:view',
  ROLES_CREATE: 'roles:create',
  ROLES_EDIT:   'roles:edit',
  ROLES_DELETE: 'roles:delete',

  // Gestión de usuarios
  USERS_VIEW:   'users:view',
  USERS_CREATE: 'users:create',
  USERS_EDIT:   'users:edit',
  USERS_DELETE: 'users:delete',

  // Chat
  CHAT_USE:  'chat:use',
  CHAT_VIEW: 'chat:view',

  // TRM
  TRM_VIEW:   'trm:view',
  TRM_CREATE: 'trm:create',

  // Proveedores
  SUPPLIERS_VIEW:   'suppliers:view',
  SUPPLIERS_CREATE: 'suppliers:create',
  SUPPLIERS_EDIT:   'suppliers:edit',
  SUPPLIERS_DELETE: 'suppliers:delete',

  // Tenants / Empresas — exclusivo del superadministrador
  TENANTS_VIEW:         'tenants:view',
  TENANTS_CREATE:       'tenants:create',
  TENANTS_EDIT:         'tenants:edit',
  TENANTS_ACTIVATE:     'tenants:activate',
  TENANTS_MANAGE_USERS: 'tenants:manage_users',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
